import { Injectable } from '@angular/core';
import { ApiClientService } from 'api-services';
import { Observable } from 'rxjs';
import { catchError, throwError } from 'rxjs';
import { tap } from 'rxjs';
import { AuthService } from 'services';
import { GridStateService } from '../services/grid-state.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private gridStateService: GridStateService
  ) { }

  public loginUser(userLogin: any) {

    return this.apiClient.post('api/user/login', userLogin, null, null, true);
  }
  public getUser(userId: number) {

    return this.apiClient.get(`api/user/userlog/${userId}`, null, null);
  }
  //public setToken(token: string) {
  //  this.authService.userLoggedIn(token);
  //  this.apiClient.setHeader("Authorization", `bearer ${token}`);
  //}
  public setToken(tokenresponse: any, token: string) {
    this.authService.isLoggingOut = false;
    this.authService.userLoggedIn(tokenresponse);
    this.apiClient.setHeader('Authorization', `bearer ${token}`);
  }
  public listUser() {

    return this.apiClient.get('api/user/list');
  }

  public userReg(userReg: any) {

    return this.apiClient.post('api/tenant', userReg, null, true);
  }

  public userActivate(activateUser: any) {

    return this.apiClient.post('api/user/activate', activateUser, null, false);
  }
  public setForgotPwd(password: any) {

    return this.apiClient.post('api/user/setforgotpassword', password, null, false);
  }
  public setPwd(password: any) {

    return this.apiClient.post('api/user/setpassword', password, null, false);
  }
  public resetPwd(password: any) {

    return this.apiClient.post('api/user/resetpassword', password, null, false);
  }
  public chgPwd(password: any) {

    return this.apiClient.post('api/user/changepassword', password, null, false);
  }
  public forgetPwd(userName: any) {

    return this.apiClient.post('api/user/forgetpassword', userName, null, true);
  }

  public sendActivationLink(email: any) {

    return this.apiClient.post('api/user/sendactivation', email, null, true);
  }


  public userProfileUpdate(userProfile: any) {

    return this.apiClient.post('api/tenant/profile', userProfile, null, false);
  }

  public getUserProfile(id: number) {

    return this.apiClient.get(`api/tenant/${id}`, null, null, false);
  }
  public domainupdate(userOtherProf: any) {

    return this.apiClient.post('api/tenant/domainupdate', userOtherProf, null, false);
  }
  public userOtherProf(userOtherProf: any) {

    return this.apiClient.post('api/tenant/otherprofile', userOtherProf, null, false);
  }

  public updateNIPRCredential(userOtherProf: any) {

    return this.apiClient.post('api/tenant/updateNIPRCredential', userOtherProf, null, false);
  }
  public validatePasswordActivation(validateUser: any) {
    return this.apiClient.post(`api/user/validatepasswordactivation`, validateUser, null, false);
  }
  public validateForgotPasswordActivation(validateUser: any) {
    return this.apiClient.post(`api/user/validateForgotPasswordActivation`, validateUser, null, false);
  }

  public creditCardProcessingFeeMessage() {
    return this.apiClient.get(`api/SystemSettings/creditCardProcessingFeeMessage`, null, null, false);
  }

  public getSystemSettingByKey(key: string) {
    return this.apiClient.get(`api/SystemSettings/getSystemSettingByKey/${key}`, null, null, false);
  }

  public creditCardProcessingFeeEnabled() {
    return this.apiClient.get(`api/SystemSettings/creditCardProcessingFeeEnabled`, null, null, false);
  }

  public logout() {
    setTimeout(() => {
      this.gridStateService.clearAll();
    }, 2000);

    localStorage.clear();
    sessionStorage.clear();

    this.apiClient.post(`api/user/userSignOut`, 1, null, false, true).subscribe(
      (response: any) => {
        if (response) {
         
        }
      },
      (error: any) => {
        
      }
    )
    
  }

  public UserSignOut() {
    return this.apiClient.post(`api/user/userSignOut`, 1, null, false, true);
  }

  public UpdateUserStatus(user: any) {
    return this.apiClient.post(`api/user/updateUserStatus`, user, null, true);
  }

  public refreshToken(showloading: boolean = true): Observable<any> {
    const token = localStorage.getItem("token");
    const deviceId = localStorage.getItem("deviceId");

    if (!token || !deviceId) {
      localStorage.clear();
      return throwError(() => new Error("Missing tokens"));
    }

    const userRole = localStorage.getItem("userRole")?.toLowerCase() ?? "";
    const userId =
      userRole === "individual user"
        ? localStorage.getItem("individualAccountStagingId")
        : localStorage.getItem("userId");

    const tokenModel = {
      token,
      deviceId,
      tokenGuId: localStorage.getItem("tokenGuId") ?? "",
      userId: userId ?? "",
    };

    const url =
      userRole === "individual user"
        ? `api/IndividualLogin/refresh-token`
        : `api/User/refresh-token-new`;

    return this.apiClient.post(url, tokenModel, null, showloading, true).pipe(
      tap((response: any) => {
        const { accessToken, deviceId, propToken } = response;
        localStorage.setItem("token", accessToken);
        localStorage.setItem("deviceId", deviceId);
        this.setToken(propToken, accessToken);
      }),
      catchError((err) => {
        return throwError(() => err);
      })
    );
  }

}
